export default __webpack_public_path__ + "static/media/mummabulle.109449ea.jpg";